import { useEffect, useState } from "react";

import BarangayStats from "./BarangayStats";
import MunicipalStats from "./MunicipalStats";
import ProvincialDistrictStats from "./ProvincialDistrictStats";
import { useLocation } from "react-router-dom";

interface CandidateStatsProps {
}

const CandidateStats: React.FC<CandidateStatsProps> = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [type, setType] = useState<string | null>(null);
  const [position, setPosition] = useState<string>("");

  useEffect(() => {
    const typeParam = searchParams.get('type');
    const positionParam = searchParams.get('position');

    setType(typeParam);
    setPosition(positionParam ?? "");
  }, [location.search]);

  return (
    <>
      {(type === "district") && (<ProvincialDistrictStats region={searchParams.get('region') ?? ""} province={searchParams.get('province') ?? ""} district={searchParams.get('district') ?? ""} position={position} />)}
      {(type === "municipal") && (<MunicipalStats region={searchParams.get('region') ?? ""} province={searchParams.get('province') ?? ""} district={searchParams.get('district') ?? ""} municipal={searchParams.get('municipal') ?? ""} position={position} />)}
      {(type === "barangay") && (<BarangayStats region={searchParams.get('region') ?? ""} province={searchParams.get('province') ?? ""} district={searchParams.get('district') ?? ""} municipal={searchParams.get('municipal') ?? ""} barangay={searchParams.get('barangay') ?? ""} position={position} />)}
    </>
  );
};

export default CandidateStats;
